import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3c4f20b6&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4f20b6')) {
      api.createRecord('3c4f20b6', component.options)
    } else {
      api.reload('3c4f20b6', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=3c4f20b6&", function () {
      api.rerender('3c4f20b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/List.vue"
export default component.exports